import {
  ActivationRequiredWarning,
  PageBanner,
  QuickTable,
  QuickTableFilterTabs,
} from "../../components";
import { subscriptionDisplayFormatter } from "./subscriptionsDisplayFormatter";
import { ISubscriptionsViewProps } from "./Subscriptions";

import recurringIcon from "../../assets/icons/recurring.svg";
import { CreateSubscription } from "./CreateSubscription";

export const View = (props: ISubscriptionsViewProps) => {
  return (
    <>
      <PageBanner
        iconSource={recurringIcon}
        pageTitle={"Subscriptions"}
        pageSubtitle={"Create a subscription for your customers"}
        pageDescription={
          "Create a subscription and accept recurring payments globally."
        }
        hideLink
        linkTitle={""}
        linkSubtitle={""}
        linkButtonText={""}
        linkButtonUrl={""}
      />

      <ActivationRequiredWarning
        title="To create a subscription, you need to activate your profile"
        subtitle="Our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <QuickTable
        id="subscriptionsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={subscriptionDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText={"Create a subscription"}
      />

      <CreateSubscription
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />
    </>
  );
};
